module.exports = __webpack_public_path__ + "static/media/facebook.e54cb057.svg";